export default __webpack_public_path__ + "static/media/1.e7ddd5d9.jpg";